module.exports = __webpack_public_path__ + "assets/img/1b9e94bc6e3c28ddb5f4fecfc7fea7bb.webp";